<template>
  <div class="app-container">
    <div class="global-header-wrap">
      <h3>配置</h3>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '10px' }">
      <div slot="header">
        <div class="global-table-header">
          <!-- <div></div> -->
          <ListSearch ref="listSearch" @listSearchEvn="listSearchEvn" />
          <button class="global-button-style" @click="create">
            新建
          </button>
        </div>
      </div>
      <div class="global-body-wrap">
        <TableView
          :tableData="tableData"
          :tableProp="tableProp"
          handleWidth="200"
          :handleBtn="handleBtn"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="params.pageSize"
        :total="total"
        @pageNum="pageNum"
      />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TableView from '@/components/tableView'
import Pagination from '@/components/pagination'
import ListSearch from '@/components/listSearch'
export default {
  components: {
    ListSearch,
    TableView,
    Pagination
  },
  computed: {
    ...mapGetters(['userInfo']),
    tableProp() {
      let tableProp = [
        {
          prop: 'key',
          label: 'KEY'
        },
        {
          prop: 'type',
          label: '类型'
        },
        {
          prop: 'desc',
          label: '描述'
        },
        {
          prop: 'updatedAt',
          label: '更新时间'
        }
      ]
      return tableProp
    },
    handleBtn() {
      return [
        { style: 'checkDetailsBtn', type: 'edit', title: '编辑' },
        { style: 'delBtn', type: 'del', title: '删除' }
      ]
    }
  },
  data() {
    return {
      loading: false,
      currentItem: null,
      tableData: [],
      total: 0,
      params: { pageSize: 20, page: 1 }
    }
  },
  methods: {
    async getList() {
      let res = await this.$http.getAdminConfigList(this.params)
      this.tableData = res.data.rows
      this.total = res.data.rowCount
    },
    create() {
      this.$router.push({
        name: 'addAdminConfig'
      })
    },

    edit(data) {
      this.$router.push({
        name: 'addAdminConfig',
        query: {
          id: data.id
        }
      })
    },
    async del(data) {
      try {
        await this.$confirm(null, this.$t('alertMsg.delConfirm'), {
          confirmButtonText: this.$t('commonMsg.confirm'),
          cancelButtonText: this.$t('commonMsg.cancel'),
          showClose: false,
          center: true
        })
        await this.$http.delAdminConfig({ ids: [data.id] })
        this.getList()
      } catch (error) {}
    },

    tableHandle({ type, data }) {
      switch (type) {
        case 'edit':
          this.edit(data)
          break
        case 'del':
          this.del(data)
          break

        default:
          break
      }
    },

    listSearchEvn(val) {
      this.params.query = val
      this.getList()
    },
    pageNum(page) {
      this.params.page = page
      this.getList()
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="scss" scoped></style>
